import React, { useState } from 'react';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { Alert, Badge, Card, Descriptions, Spin, Typography } from 'antd';
import { BENEFICIARY_TYPE_MASTER, TRANSFER_STATUS_TYPES } from '../../../constants';
import { handleApiExceptions } from '../../../app_methods';
import { Text3, Text4 } from '../../../styles';
import moment from 'moment';


const TallyInvoiceAttemptsDrawer = (props) => {
    const tallyInvoice = props.tallyInvoice || {};
    const [attempts, setAttempts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchPaymentAttempts = async () => {
        setIsLoading(true);
        // const response = await tallyInvoice.fetchAttempts({submerchant_id: tallyInvoice.submerchant});
        const response = await tallyInvoice.fetchAttempts();
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        setAttempts(response.data.attempts);
        setIsLoading(false);
    };

    const renderCardTitle = (attempt) => {
        return (
            <div className="mb-2 d-flex justify-content-between">
                <div>
                    {attempt.status ? 
                            <Badge
                            size="large"
                            color={TRANSFER_STATUS_TYPES[attempt.status].color}
                            text={<Text4 strong>{TRANSFER_STATUS_TYPES[attempt.status].label}</Text4>}
                        />
                    : null}
                    
                </div>
                <div className="d-flex align-items-center justify-content-end">
                    <Text4 type="secondary">{attempt.created_at && moment(attempt.created_at).format("LLL")}</Text4>
                </div>
            </div>
        )
    };

    const renderCardDetails = (attempt) => {
    console.log(attempt)

        return (
            <>
                <div className="row">
                    <div className="col-6">
                        <Text4 type="secondary" strong>Beneficiary Name:</Text4>
                    </div>
                    <div className="col-6">
                        <Text4>{attempt.beneficiary_name}</Text4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Text4 type="secondary" strong>Beneficiary Account No.:</Text4>
                    </div>
                    <div className="col-6">
                        <Text4>{attempt.beneficiary_account_number}</Text4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <Text4 type="secondary" strong>Beneficiary IFSC Code:</Text4>
                    </div>
                    <div className="col-6">
                        <Text4>{attempt.beneficiary_account_ifsc}</Text4>
                    </div>
                </div>
                {
                    (attempt.status == "failure" ||  attempt.status == "success") && attempt.utr?
                        <div className="row">
                            <div className="col-6">
                                <Text4 type="secondary" strong>UTR: </Text4>
                            </div>
                            <div className="col-6">
                                <Text4>{attempt.utr}</Text4>
                            </div>
                        </div>
                        :
                        null
                }
                {
                    attempt.status == "failure" ?
                        <div className="mt-2 row">
                            <div className="col-12">
                                <Text4 type="secondary" strong>Failure Reason: </Text4>
                                <Text4>{attempt.failure_reason || "---"}</Text4>
                            </div>
                        </div>
                        :
                        null
                }
            </>
        )
    }

    return (
        <EaseDrawer
            className="payment-attempts-drawer-wrapper"
            visible={props.visible}
            onOpen={fetchPaymentAttempts}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={500}
        >
            <Typography.Title className="mt-4 mb-4" level={4}>Payment Attempts</Typography.Title>
            {
                isLoading ?
                    <div style={{ width: "100%", height: "84vh" }} className="d-flex justify-content-center align-items-center">
                        <Spin className="mt-4" tip="Loading..." spinning={isLoading} />
                    </div>
                    :
                    attempts.length ?
                        attempts.map((attempt, index) => {
                            return (
                                <Card
                                    className="mb-2"
                                    size="small"
                                    title={false}
                                >
                                    {renderCardTitle(attempt)}
                                    {renderCardDetails(attempt)}
                                </Card>
                            );
                        })
                        :
                        <Alert
                            message="Nothing to show"
                            description="No payment attempts have been made so far with this invoice."
                            type="info"
                            showIcon
                        />
            }
        </EaseDrawer>
    )
};

export { TallyInvoiceAttemptsDrawer };